export enum EAdminInviteMode {
  EmailPassword = 'email_password',
  SSO = 'sso',
}

export enum EAdminRole {
  Manager = 'manager',
  Operator = 'operator',
  Unknown = 'unknown',
}
